/**
 * The SVG icon of the Duke logo with the text.
 * @props The HTML Chakra props of the SVG element.
 */
export function IconWithTextLightLogo(props) {
  return (
    <svg
      width="116"
      height="32"
      viewBox="0 0 116 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Duke-light-brand-purple-brand">
        <g id="Duke-emblem-purple">
          <path
            id="Rectangle 39"
            d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16V32H16C7.16344 32 0 24.8366 0 16Z"
            fill="#8445BC"
          />
          <g id="Mask group">
            <mask
              id="mask0_1477_319538"
              style={{ maskType: 'alpha' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="32"
              height="32"
            >
              <path
                id="Rectangle 40"
                d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16V32H16C7.16344 32 0 24.8366 0 16Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_1477_319538)">
              <path
                id="d"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.1692 16.2169C25.1714 16.2991 25.1725 16.3815 25.1725 16.4642C25.1725 21.4447 21.2204 25.4933 15.9831 25.4933C10.7779 25.4933 6.82581 21.4447 6.82581 16.4642C6.82581 11.4516 10.7779 7.43503 15.9831 7.43503C17.7815 7.43503 19.4401 7.92048 20.8388 8.76447V0H25.1725V16.2155C25.1725 16.2155 25.1714 16.216 25.1692 16.2169ZM20.7706 16.4321C20.7706 19.1312 18.6499 21.284 16.0152 21.284C13.3484 21.284 11.2599 19.1312 11.2599 16.4321C11.2599 13.7329 13.3484 11.5801 16.0152 11.5801C18.6499 11.5801 20.7706 13.7329 20.7706 16.4321Z"
                fill="white"
              />
            </g>
          </g>
        </g>
        <g id="duke-light">
          <path
            id="e"
            d="M107.077 25.4923C101.486 25.4923 97.8872 21.5399 97.8872 16.4951C97.8872 11.4502 101.807 7.43359 106.981 7.43359C112.186 7.43359 115.946 11.1931 115.946 16.3344V18.0053H102.161C102.739 20.2546 104.571 21.6685 107.141 21.6685C108.79 21.6685 110.004 21.0906 110.868 20.1333C111.75 20.6924 113.289 21.6685 114.382 22.3617C112.701 24.2919 110.416 25.4923 107.077 25.4923ZM106.981 11.1931C104.732 11.1931 102.996 12.5106 102.289 14.535H111.544C110.965 12.3821 109.294 11.1931 106.981 11.1931Z"
            fill="#11181C"
          />
          <path
            id="k"
            d="M92.8966 24.9635L87.9993 17.8238L85.3427 20.8013V24.9635H80.9575V0H85.3427V15.7107L92.3525 7.67453H97.6338L91.1361 15.0383L97.9539 24.9635H92.8966Z"
            fill="#11181C"
          />
          <path
            id="u"
            d="M69.5233 25.4962C63.9477 25.4962 61.0404 21.9694 61.0404 16.0806V7.70312H65.6814V16.1777C65.6814 19.0897 66.7516 21.0958 69.5233 21.0958C72.295 21.0958 72.8647 19.0897 72.8647 16.1777V7.70312H77.5057V16.0806C77.5057 21.9694 75.0989 25.4962 69.5233 25.4962Z"
            fill="#11181C"
          />
          <path
            id="d_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M57.1716 16.2177C57.1737 16.2999 57.1748 16.3823 57.1748 16.465C57.1748 21.4457 53.2224 25.4946 47.9845 25.4946C42.7789 25.4946 38.8264 21.4457 38.8264 16.465C38.8264 11.4521 42.7789 7.4354 47.9845 7.4354C49.7832 7.4354 51.4419 7.92088 52.8407 8.76491V0H57.1748V16.2163C57.1748 16.2163 57.1737 16.2168 57.1716 16.2177ZM52.7725 16.4329C52.7725 19.1321 50.6517 21.2851 48.0167 21.2851C45.3496 21.2851 43.2609 19.1321 43.2609 16.4329C43.2609 13.7336 45.3496 11.5807 48.0167 11.5807C50.6517 11.5807 52.7725 13.7336 52.7725 16.4329Z"
            fill="#11181C"
          />
        </g>
      </g>
    </svg>
  );
}

export default IconWithTextLightLogo;
